(function() {
  var STORAGE_KEY = 'crystalRarityDraftOrderContext';
  var MAX_CONTEXT_AGE_MS = 1000 * 60 * 60 * 24;
  var OPEN_BOX_TRIGGER_VARIANT_ID = 53121661272378;

  function safeJsonParse(value) {
    if (!value) {
      return null;
    }

    try {
      return JSON.parse(value);
    } catch (_error) {
      return null;
    }
  }

  function normalizeWorkerUrl(rawUrl) {
    return String(rawUrl || '').replace(/\/$/, '');
  }

  function getStorage() {
    try {
      return window.localStorage;
    } catch (_error) {
      return null;
    }
  }

  function buildContext(context) {
    if (!context || !context.draftOrderId) {
      return null;
    }

    return {
      draftOrderId: context.draftOrderId,
      email: context.email || '',
      orderName: context.orderName || '',
      invoiceUrl: context.invoiceUrl || '',
      totalPrice: context.totalPrice || '',
      currencyCode: context.currencyCode || '',
      workerUrl: normalizeWorkerUrl(context.workerUrl),
      workerSecret: context.workerSecret || '',
      searchPageUrl: context.searchPageUrl || window.location.pathname,
      savedAt: context.savedAt || new Date().toISOString()
    };
  }

  function isContextFresh(context) {
    if (!context || !context.savedAt) {
      return false;
    }

    var savedAt = new Date(context.savedAt).getTime();

    if (!savedAt) {
      return false;
    }

    return Date.now() - savedAt <= MAX_CONTEXT_AGE_MS;
  }

  function saveContext(context) {
    var storage = getStorage();
    var normalized = buildContext(context);

    if (!storage || !normalized) {
      return null;
    }

    storage.setItem(STORAGE_KEY, JSON.stringify(normalized));
    return normalized;
  }

  function clearContext() {
    var storage = getStorage();

    if (storage) {
      storage.removeItem(STORAGE_KEY);
    }
  }

  function readContext() {
    var storage = getStorage();
    var parsed;

    if (!storage) {
      return null;
    }

    parsed = safeJsonParse(storage.getItem(STORAGE_KEY));

    if (!buildContext(parsed) || !isContextFresh(parsed)) {
      clearContext();
      return null;
    }

    return parsed;
  }

  function isHiddenCartItem(item) {
    if (!item) {
      return true;
    }

    if (Number(item.variant_id) === OPEN_BOX_TRIGGER_VARIANT_ID) {
      return true;
    }

    if (item.properties && item.properties._hidden === 'true') {
      return true;
    }

    return String(item.product_title || '').indexOf('Open Box Shipping Trigger') >= 0;
  }

  function getEligibleCartLines(cart) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];

    return items
      .map(function(item, index) {
    var priceOverride = null;
    if (item.price != null && cart && cart.currency) {
      var amount = Number(item.price);
      if (!Number.isNaN(amount)) {
        var formatted = (amount / 100).toFixed(2);
        priceOverride = {
          amount: formatted,
          currencyCode: cart.currency
        };
      }
    }

    var variantId = item.id ? 'gid://shopify/ProductVariant/' + item.id : '';
    var lineItem = {
      line: index + 1,
      key: item.key,
      quantity: item.quantity,
      variantId: variantId,
      title: item.product_title || item.title || ''
    };

    if (!variantId && priceOverride) {
      lineItem.priceOverride = priceOverride;
    }

    return lineItem;
      })
      .filter(function(item, index) {
        return !isHiddenCartItem(items[index]) && item.variantId && item.quantity > 0;
      });
  }

  function fetchCartJson() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    }).then(function(response) {
      if (!response.ok) {
        throw new Error('Unable to load your cart right now.');
      }

      return response.json();
    });
  }

  function removeCartLineByKey(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: 0
      })
    }).then(function(response) {
      if (!response.ok) {
        throw new Error('Unable to update your cart after syncing to the live sale order.');
      }

      return response.json();
    });
  }

  function clearConsumedCartLines(lines) {
    var consumed = Array.isArray(lines) ? lines : [];
    var sequence = Promise.resolve();

    consumed.forEach(function(line) {
      if (!line || !line.key) {
        return;
      }

      sequence = sequence.then(function() {
        return removeCartLineByKey(line.key);
      });
    });

    return sequence;
  }

  function syncCartToDraftOrder(options) {
    var context = readContext();
    var callbacks = options || {};
    var workerUrl;
    var syncBatchId = String(callbacks.syncBatchId || '');

    if (!context) {
      throw new Error('Your live sale order has expired. Please return to the order search page and load it again.');
    }

    workerUrl = normalizeWorkerUrl(context.workerUrl);

    if (!workerUrl) {
      throw new Error('The saved live sale order is missing Worker configuration. Please reload your order from the search page.');
    }

    if (typeof callbacks.onStart === 'function') {
      callbacks.onStart(context);
    }

    return fetchCartJson()
      .then(function(cart) {
        var cartLines = getEligibleCartLines(cart);

        if (!cartLines.length) {
          if (!context.invoiceUrl) {
            throw new Error('Checkout is not available for this live sale order. Please reload your order from the search page.');
          }

          return {
            success: true,
            draftOrderId: context.draftOrderId,
            invoiceUrl: context.invoiceUrl,
            skippedCartSync: true,
            consumedCartLines: []
          };
        }

        return fetch(workerUrl + '/draft-orders/' + encodeURIComponent(context.draftOrderId) + '/sync-cart', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Worker-Secret': context.workerSecret || ''
          },
          body: JSON.stringify({
            draftOrderId: context.draftOrderId,
            syncBatchId: syncBatchId,
            cartLines: cartLines
          })
        });
      })
      .then(function(response) {
        if (response && response.skippedCartSync) {
          return response;
        }

        return response.json().catch(function() {
          return {};
        }).then(function(data) {
          if (!response.ok || !data.success) {
            throw new Error(data && data.message ? data.message : 'Unable to sync your cart to the live sale order.');
          }

          return data;
        });
      })
      .then(function(data) {
        return data;
      })
      .then(function(data) {
        if (typeof callbacks.onComplete === 'function') {
          callbacks.onComplete(data, context);
        }

        return data;
      })
      .catch(function(error) {
        if (typeof callbacks.onError === 'function') {
          callbacks.onError(error, context);
        }

        throw error;
      });
  }

  window.CrystalRarityDraftOrder = {
    storageKey: STORAGE_KEY,
    maxContextAgeMs: MAX_CONTEXT_AGE_MS,
    saveContext: saveContext,
    readContext: readContext,
    clearContext: clearContext,
    isContextFresh: isContextFresh,
    getEligibleCartLines: getEligibleCartLines,
    fetchCartJson: fetchCartJson,
    syncCartToDraftOrder: syncCartToDraftOrder
  };
})();
